export const socialLinks = [
    {
        id: 1,
        name: 'Website',
        icon: 'globe',
        url: '#',
    },
    {
        id: 2,
        name: 'GitHub',
        icon: 'github',
        url: 'https://github.com/PappaLaity',
    },
    {
        id: 3,
        name: 'Twitter',
        icon: 'twitter',
        url: 'https://twitter.com/Pappalaity',
    },
    {
        id: 4,
        name: 'LinkedIn',
        icon: 'linkedin',
        url: 'https://www.linkedin.com/in/pappalaity',
    },
    // {
    //     id: 5,
    //     name: 'YouTube',
    //     icon: 'youtube',
    //     url: 'https://www.youtube.com/c/realstoman',
    // },
];
